exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footersty[data-v-edbb25a2]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#3d4656;font-size:14px;z-index:99}.footersty p[data-v-edbb25a2]{margin-top:2px;margin-bottom:2px}.footersty p img[data-v-edbb25a2]{vertical-align:middle;height:auto;width:auto}.footersty p .img-sty[data-v-edbb25a2]{height:30px}", ""]);

// exports
